import type { Breadcrumb } from "../../components/breadcrumbs.svelte";
import { SITE_ORIGIN } from "./constants";
import { htmlToPlainText } from "./html-to-plain-text";

export function buildOrganizationJsonLd() {
	return {
		"@context": "https://schema.org",
		"@type": "EducationalOrganization",
		name: "Balanced Body®ピラティスインストラクター養成講座",
		url: SITE_ORIGIN,
		logo: `${SITE_ORIGIN}/balanced-body-logo.webp`,
		sameAs: [
			"https://www.instagram.com/v8_instructor_training/",
			"https://www.youtube.com/watch?v=XhlvH7zv8Cc&t=1s",
			"https://v8pilatesacademy.com/",
		],
	};
}

export function buildBreadcrumbListJsonLd(breadcrumbs: Breadcrumb[]) {
	return {
		"@context": "https://schema.org",
		"@type": "BreadcrumbList",
		itemListElement: breadcrumbs.map(({ label, href }, index) => ({
			"@type": "ListItem",
			position: index + 1,
			name: label,
			item: `${SITE_ORIGIN}${href}`,
		})),
	};
}

export function buildFaqPageJsonLd(items: { title: string; content: string }[]) {
	return {
		"@context": "https://schema.org",
		"@type": "FAQPage",
		mainEntity: items.map(({ title, content }) => ({
			"@type": "Question",
			name: title,
			acceptedAnswer: {
				"@type": "Answer",
				text: htmlToPlainText(content),
			},
		})),
	};
}

export function buildCourseJsonLd(params: {
	name: string;
	description: string;
	url: string;
}) {
	return {
		"@context": "https://schema.org",
		"@type": "Course",
		name: params.name,
		description: params.description,
		url: params.url,
		provider: {
			"@type": "EducationalOrganization",
			name: "Balanced Body®ピラティスインストラクター養成講座",
			sameAs: SITE_ORIGIN,
		},
	};
}
